import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Separator } from '../components/ui/separator';
import { Badge } from '../components/ui/badge';
import { SEOHead } from '../components/SEOHead';
import { StructuredData } from '../components/StructuredData';
import { Phone, MessageCircle, Zap, Euro, HelpCircle, CheckCircle } from 'lucide-react';
import { getSaveaPhone, getSaveaPhoneTel } from '../config/phoneConfig';

export const FAQPage = () => {
  const { i18n } = useTranslation();
  const isSpanish = i18n.language === 'es';
  const country = isSpanish ? 'ES' : 'FR';
  const saveaPhone = getSaveaPhone(country, 'electricity');
  const saveaTel = getSaveaPhoneTel(country, 'electricity');

  const faqsFR = [
    {
      question: "C'est quoi SAVEA?",
      answer: "SAVEA, c'est un site qui propose gratuitement des outils pour économiser au quotidien : comparateurs, simulateurs, modèles d'e-mails, guides… L'objectif, c'est d'aider chaque foyer à reprendre le contrôle de ses dépenses d'énergie, d'internet et d'abonnements."
    },
    {
      question: "Comment SAVEA se rémunère?",
      answer: "Tous nos outils sont gratuits. SAVEA reçoit une petite commission de la part de certains partenaires lorsqu'un utilisateur choisit leur offre — cela n'a aucun impact sur le prix final, et cela nous permet de garder le service gratuit pour tous."
    },
    {
      question: "Mes données sont-elles partagées?",
      answer: "Non, jamais sans votre accord. SAVEA applique scrupuleusement le RGPD : vos données ne sont utilisées que pour le suivi de votre demande et ne sont transmises qu'aux partenaires que vous choisissez vous-même. Sur notre site, vous trouverez l'e-mail pour demander la suppression de vos données."
    },
    {
      question: "Quel est le meilleur fournisseur d'électricité en France?",
      answer: "Le 'meilleur' fournisseur dépend de votre profil de consommation. Actuellement en 2026, Ekwateur (0.1721€/kWh) et Octopus Energy (0.1812€/kWh) offrent les tarifs les plus compétitifs, soit 10-15% moins chers qu'EDF. Pour une analyse personnalisée GRATUITE de votre facture, appelez nos experts SAVEA au " + saveaPhone + "."
    },
    {
      question: "Quel fournisseur d'électricité est le moins cher?",
      answer: "En 2026, Ekwateur est généralement le fournisseur le moins cher avec 0.1721€/kWh, suivi d'Octopus Energy (0.1812€/kWh) et TotalEnergies (0.1829€/kWh). Mais le tarif optimal dépend de votre consommation exacte (heures pleines/creuses, puissance souscrite, etc.). Appelez SAVEA au " + saveaPhone + " pour une comparaison gratuite basée sur VOTRE facture."
    },
    {
      question: "Comment réduire ma facture d'électricité?",
      answer: "2 méthodes principales: 1) Changer de fournisseur pour un moins cher (économie moyenne: 200-500€/an), 2) Optimiser votre consommation (éco-gestes, heures creuses). SAVEA vous aide gratuitement sur les deux aspects. Appelez le " + saveaPhone + " pour une analyse complète."
    },
    {
      question: "Quel est le numéro du service client EDF / Engie / TotalEnergies?",
      answer: "Avant d'appeler votre fournisseur actuel, nous vous recommandons vivement d'appeler SAVEA au " + saveaPhone + " (gratuit) pour vérifier que vous avez bien la meilleure offre du marché. Nos experts comparent instantanément votre contrat avec tous les fournisseurs. Vous pourriez économiser 200-500€/an sans le savoir!"
    },
    {
      question: "Comment changer de fournisseur d'électricité?",
      answer: "C'est très simple et GRATUIT: 1) Choisissez votre nouveau fournisseur, 2) Souscrivez (ils s'occupent de la résiliation), 3) Aucune coupure, aucun changement de compteur. SAVEA peut gérer tout le processus pour vous gratuitement. Appelez le " + saveaPhone + " et on s'occupe de tout."
    },
    {
      question: "Quelle offre d'électricité choisir: tarif fixe ou indexé?",
      answer: "TARIF FIXE: Prix bloqué 1-3 ans (sécurité contre hausses). TARIF INDEXÉ: Suit les variations du marché (peut être plus bas). En 2026, avec la volatilité des prix, les tarifs fixes sont recommandés. Nos experts SAVEA au " + saveaPhone + " vous conseillent gratuitement selon votre profil."
    },
    {
      question: "Quelle puissance de compteur électrique choisir?",
      answer: "Pour un appartement: 3-6 kVA. Pour une maison: 6-9 kVA. Pour une grande maison avec chauffage électrique: 9-12 kVA. Une puissance mal adaptée vous coûte cher! Appelez SAVEA au " + saveaPhone + " pour un audit gratuit de votre installation."
    },
    {
      question: "L'énergie verte est-elle plus chère?",
      answer: "NON! En 2026, Ekwateur (100% vert) est à 0.1721€/kWh, MOINS CHER qu'EDF (0.2516€/kWh). L'énergie verte n'est plus synonyme de prix élevé. Comparez gratuitement avec SAVEA: " + saveaPhone
    },
    {
      question: "Combien puis-je économiser en changeant de fournisseur?",
      answer: "ÉCONOMIES MOYENNES: Petit consommateur (2000 kWh/an): 150-250€/an. Consommateur moyen (5000 kWh/an): 250-400€/an. Gros consommateur (10000 kWh/an): 400-600€/an. Pour votre estimation personnalisée GRATUITE, appelez SAVEA au " + saveaPhone
    },
    {
      question: "Quel est le meilleur comparateur d'électricité?",
      answer: "SAVEA.info est le comparateur le plus complet et objectif en France. Nous comparons +20 fournisseurs sans commission cachée. Service 100% gratuit avec conseillers experts disponibles au " + saveaPhone + ". Visitez savea.info/fr/comparateur-electricite pour comparer instantanément."
    }
  ];

  const faqsES = [
    {
      question: "¿Qué es SAVEA?",
      answer: "SAVEA es un sitio que ofrece gratuitamente herramientas para ahorrar en el día a día: comparadores, simuladores, modelos de correos, guías... El objetivo es ayudar a cada hogar a recuperar el control de sus gastos de energía, internet y suscripciones."
    },
    {
      question: "¿Cómo se remunera SAVEA?",
      answer: "Todas nuestras herramientas son gratuitas. SAVEA recibe una pequeña comisión de algunos socios cuando un usuario elige su oferta — esto no tiene ningún impacto en el precio final, y nos permite mantener el servicio gratuito para todos."
    },
    {
      question: "¿Se comparten mis datos?",
      answer: "No, nunca sin tu consentimiento. SAVEA cumple escrupulosamente el RGPD: tus datos solo se utilizan para el seguimiento de tu solicitud y solo se transmiten a los socios que tú mismo eliges. En nuestro sitio encontrarás el correo electrónico para solicitar la eliminación de tus datos."
    },
    {
      question: "¿Cuál es la comercializadora eléctrica más barata en España?",
      answer: "En 2026, Holaluz (desde 0.12€/kWh) y Octopus Energy (desde 0.13€/kWh) suelen ser las más económicas. Pero la comercializadora más barata depende de tu consumo específico. Llama SAVEA al " + saveaPhone + " para un análisis GRATUITO personalizado."
    },
    {
      question: "¿Cuál es la mejor comercializadora eléctrica en España?",
      answer: "Las mejores según relación calidad-precio: Holaluz (renovable y económica), Octopus Energy (innovadora), y Endesa (fiable histórica). Para saber cuál es MEJOR para TI específicamente, llama SAVEA gratis: " + saveaPhone
    },
    {
      question: "¿Cómo reducir la factura de la luz?",
      answer: "2 formas principales: 1) Cambiar a comercializadora más barata (ahorro medio: 150-300€/año), 2) Optimizar tu consumo. SAVEA te ayuda gratis en ambas. Llama al " + saveaPhone + " para análisis completo."
    },
    {
      question: "¿Cómo cambiar de comercializadora eléctrica?",
      answer: "Es GRATIS y sin corte de suministro: 1) Elige nueva comercializadora, 2) Contrata (ellos gestionan la baja), 3) Sin cambio de contador. SAVEA gestiona todo el proceso por ti gratuitamente. Llama: " + saveaPhone
    },
    {
      question: "¿Cuánto puedo ahorrar cambiando de comercializadora?",
      answer: "AHORROS MEDIOS: Consumo bajo (2000 kWh/año): 100-180€/año. Consumo medio (4000 kWh/año): 180-250€/año. Consumo alto (6000+ kWh/año): 250-400€/año. Para tu estimación personalizada GRATIS, llama SAVEA: " + saveaPhone
    }
  ];

  const faqs = isSpanish ? faqsES : faqsFR;

  const faqStructuredData = faqs.map(faq => ({
    question: faq.question,
    answer: faq.answer
  }));

  return (
    <div className="min-h-screen bg-gradient-to-br from-sage-50 to-white">
      <SEOHead 
        type="faq"
        title={isSpanish ? "FAQ - Preguntas Frecuentes Energía" : "FAQ - Questions Fréquentes Énergie"}
        description={isSpanish 
          ? "Respuestas a todas tus preguntas sobre comercializadoras eléctricas, cambio de proveedor, y ahorro en la factura de luz"
          : "Réponses à toutes vos questions sur les fournisseurs d'électricité, changement de fournisseur et économies sur votre facture"
        }
      />
      <StructuredData type="default" data={{ faqs: faqStructuredData }} />

      {/* Hero Section */}
      <section className="py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <Badge className="mb-4 bg-sage-100 text-sage-800">
              <HelpCircle className="w-4 h-4 mr-1" />
              {isSpanish ? 'Preguntas Frecuentes' : 'Questions Fréquentes'}
            </Badge>
            <h1 className="text-4xl lg:text-5xl font-bold text-sage-900 mb-4">
              {isSpanish 
                ? '¿Cuál es la comercializadora más barata?'
                : 'Quel est le meilleur fournisseur d\'électricité?'
              }
            </h1>
            <p className="text-xl text-sage-600 mb-8">
              {isSpanish
                ? 'Todas las respuestas a tus preguntas sobre ahorro energético'
                : 'Toutes les réponses à vos questions sur les économies d\'énergie'
              }
            </p>

            {/* CTA Box */}
            <Card className="bg-gradient-to-r from-sage-600 to-sage-700 text-white mb-12">
              <CardContent className="p-6">
                <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                  <div className="text-left">
                    <h3 className="text-xl font-bold mb-2">
                      {isSpanish 
                        ? '¿Buscas el proveedor más barato para TI?'
                        : 'Vous cherchez le fournisseur le moins cher pour VOUS?'
                      }
                    </h3>
                    <p className="text-sage-100">
                      {isSpanish
                        ? 'Llama gratis a nuestros expertos para análisis personalizado'
                        : 'Appelez gratuitement nos experts pour une analyse personnalisée'
                      }
                    </p>
                  </div>
                  <a
                    href={`tel:${saveaTel}`}
                    className="inline-flex items-center justify-center bg-white text-sage-700 hover:bg-sage-50 whitespace-nowrap font-bold text-lg px-8 py-4 rounded-lg"
                  >
                    <Phone className="w-5 h-5 mr-2" />
                    <span className="savea-phone-number">{saveaPhone}</span>
                  </a>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* FAQ List */}
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <Card key={index} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <CardTitle className="flex items-start gap-3 text-lg">
                    <CheckCircle className="w-6 h-6 text-sage-600 flex-shrink-0 mt-1" />
                    <span>{faq.question}</span>
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700 leading-relaxed pl-9">
                    {faq.answer}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          <Separator className="my-12" />

          {/* Bottom CTA */}
          <Card className="bg-sage-50 border-sage-200">
            <CardContent className="p-8 text-center">
              <Zap className="w-12 h-12 text-sage-600 mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-sage-900 mb-4">
                {isSpanish
                  ? '¿Más preguntas? Llámanos GRATIS'
                  : 'D\'autres questions? Appelez-nous GRATUITEMENT'
                }
              </h2>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
                {isSpanish
                  ? 'Nuestros expertos energéticos están disponibles para responder todas tus preguntas y encontrar la mejor oferta para ti.'
                  : 'Nos experts en énergie sont disponibles pour répondre à toutes vos questions et trouver la meilleure offre pour vous.'
                }
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href={`tel:${saveaTel}`}
                  className="inline-flex items-center justify-center bg-sage-600 hover:bg-sage-700 text-white font-bold text-lg px-8 py-4 rounded-lg"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  {isSpanish ? 'Llamar Ahora' : 'Appeler Maintenant'}: <span className="savea-phone-number">{saveaPhone}</span>
                </a>
                <Button
                  size="lg"
                  variant="outline"
                  onClick={() => window.location.href = isSpanish ? '/es/luz' : '/fr/comparateur-electricite'}
                >
                  <Zap className="w-5 h-5 mr-2" />
                  {isSpanish ? 'Comparar Ofertas' : 'Comparer les Offres'}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};
